import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pools: [],
  tenants: [],
  isLoading: false,
  error: null
};

const poolSlice = createSlice({
  name: 'pool',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Fetch pools success
    fetchPoolsSuccess: (state, action) => {
      state.pools = action.payload;
      state.isLoading = false;
    },
    // Create new pool success
    createPoolSuccess: (state, action) => {
      state.pools.push(action.payload);
      state.isLoading = false;
    },
    // Delete pool success
    deletePoolSuccess: (state, action) => {
      state.pools = state.pools.filter(pool => pool.id !== action.payload);
      state.isLoading = false;
    },
    // Fetch tenants success
    fetchTenantsSuccess: (state, action) => {
      state.tenants = action.payload.data.content;
      state.isLoading = false;
    },
    // Create new tenant success
    createTenantSuccess: (state, action) => {
      state.tenants.push(action.payload);
      state.isLoading = false;
    },
    // Delete tenant success
    deleteTenantSuccess: (state, action) => {
      state.tenants = state.tenants.filter(
        tenant => tenant.id !== action.payload
      );
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchPoolsSuccess,
  createPoolSuccess,
  deletePoolSuccess,
  fetchTenantsSuccess,
  createTenantSuccess,
  deleteTenantSuccess
} = poolSlice.actions;

export default poolSlice.reducer;
